import React, { useEffect, useState } from 'react';
import { getSlotDetail } from '../../../api/workshop/workshop.api';

const WorkshopDetailSummary = ({
  slotId,
  onDetailLoaded,
  stats: statsProp,
}) => {
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!slotId) return;
    const fetchDetail = async () => {
      try {
        const data = await getSlotDetail(slotId);
        setDetail(data);
        onDetailLoaded?.(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchDetail();
  }, [slotId, onDetailLoaded]);

  const stats = statsProp ?? detail?.stats;
  if (!stats) return null;

  if (!detail) return null;

  return (
    <div className='flex flex-col items-start justify-center w-full pb-[60px]'>
      <div className='flex max-w-[480px] px-6 py-4 items-start gap-6 bg-grayscale-gray00 rounded-[15px] w-full typo-b13'>
        <div className='flex flex-col items-start gap-2 w-full'>
          <div className='text-text-secondary'>
            Confirmed:{' '}
            <span className='text-text-accent'>{stats.confirmed}</span>
            <span>/{stats.maxParticipants}</span>
          </div>
          <div className='text-text-secondary'>
            Canceled:{' '}
            <span>
              {stats.canceled}/{stats.maxParticipants}
            </span>
          </div>
          <div className='text-text-secondary'>
            Left:{' '}
            <span>
              {stats.left}/{stats.maxParticipants}
            </span>
          </div>
        </div>
        <div className='flex flex-col items-start gap-2 w-full'>
          <div className='text-text-secondary'>
            Attended:{' '}
            <span>
              {stats.attended}/{stats.maxParticipants}
            </span>
          </div>
          <div className='text-text-secondary'>
            Absent:{' '}
            <span>
              {stats.absent}/{stats.maxParticipants}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkshopDetailSummary;
